export default function EFDrone(props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 38 39" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="Drone_icon" clipPath="url(#clip0_94_5380)">
                <g id="Group">
                    <path
                        id="Vector"
                        d="M23.6001 13.5703L25.9465 11.2246C26.3785 10.7926 27.0792 10.7926 27.5119 11.2246L27.9493 11.6614C28.3813 12.0941 28.3813 12.7947 27.9493 13.2274L25.6029 15.5731"
                        stroke="currentColor"
                        strokeWidth="0.985632"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <g id="Group 161268611">
                        <path
                            id="Vector_2"
                            d="M29.1195 10.0536L27.7354 11.4377"
                            stroke="currentColor"
                            strokeWidth="1.28132"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            id="Vector_3"
                            d="M29.4479 9.72513C30.0831 10.3602 31.1128 10.3602 31.7479 9.72513C32.383 9.09007 32.383 8.06027 31.7479 7.42521C31.1128 6.7901 30.0831 6.7901 29.4479 7.42521C28.8129 8.06027 28.8129 9.09007 29.4479 9.72513Z"
                            stroke="currentColor"
                            strokeWidth="1.28132"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            id="Vector_4"
                            d="M24.6841 2.66138L29.1007 7.07799"
                            stroke="currentColor"
                            strokeWidth="1.28132"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            id="Vector_5"
                            d="M32.0762 10.0536L36 13.9774"
                            stroke="currentColor"
                            strokeWidth="1.28132"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <g id="Group 161268613">
                        <g id="Group 161268609">
                            <path
                                id="Vector_6"
                                d="M8.55254 29.1091C7.91742 28.474 6.88768 28.474 6.25256 29.1091C5.61749 29.7442 5.61749 30.774 6.25256 31.409C6.88768 32.0441 7.91742 32.0441 8.55254 31.409C9.18761 30.774 9.18761 29.7442 8.55254 29.1091Z"
                                stroke="currentColor"
                                strokeWidth="1.28132"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                id="Vector_7"
                                d="M13.3164 36.1729L8.89979 31.7562"
                                stroke="currentColor"
                                strokeWidth="1.28132"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                id="Vector_8"
                                d="M5.92432 28.7806L2.00051 24.8568"
                                stroke="currentColor"
                                strokeWidth="1.28132"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </g>
                        <path
                            id="Vector_9"
                            d="M8.88102 28.7807L10.2651 27.3965"
                            stroke="currentColor"
                            strokeWidth="1.28132"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <g id="Group 161268612">
                        <g id="Group 161268609_2">
                            <path
                                id="Vector_10"
                                d="M8.55205 9.72513C7.91693 10.3602 6.88719 10.3602 6.25207 9.72513C5.617 9.09007 5.617 8.06027 6.25207 7.42521C6.88719 6.7901 7.91693 6.7901 8.55205 7.42521C9.18712 8.06027 9.18712 9.09007 8.55205 9.72513Z"
                                stroke="currentColor"
                                strokeWidth="1.28132"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                id="Vector_11"
                                d="M13.3159 2.66138L8.8993 7.07799"
                                stroke="currentColor"
                                strokeWidth="1.28132"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                id="Vector_12"
                                d="M5.92383 10.0536L2.00002 13.9774"
                                stroke="currentColor"
                                strokeWidth="1.28132"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </g>
                        <path
                            id="Vector_13"
                            d="M8.88053 10.0536L10.2646 11.4377"
                            stroke="currentColor"
                            strokeWidth="1.28132"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <g id="Group 161268614">
                        <g id="Group 161268609_3">
                            <path
                                id="Vector_14"
                                d="M29.4479 29.1091C30.0831 28.474 31.1128 28.474 31.7479 29.1091C32.383 29.7442 32.383 30.774 31.7479 31.409C31.1128 32.0441 30.0831 32.0441 29.4479 31.409C28.8129 30.774 28.8129 29.7442 29.4479 29.1091Z"
                                stroke="currentColor"
                                strokeWidth="1.28132"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                id="Vector_15"
                                d="M24.6841 36.1729L29.1007 31.7562"
                                stroke="currentColor"
                                strokeWidth="1.28132"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                id="Vector_16"
                                d="M32.0762 28.7806L36 24.8568"
                                stroke="currentColor"
                                strokeWidth="1.28132"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </g>
                        <path
                            id="Vector_17"
                            d="M29.1195 28.7807L27.7354 27.3965"
                            stroke="currentColor"
                            strokeWidth="1.28132"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <g id="Group 161268618">
                        <path
                            id="Vector_18"
                            d="M14.6738 13.5703L23.3621 13.5682"
                            stroke="currentColor"
                            strokeWidth="1.28132"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            id="Vector_19"
                            d="M25.3675 15.5737L25.3647 23.2619"
                            stroke="currentColor"
                            strokeWidth="1.28132"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            id="Vector_20"
                            d="M23.3628 13.5703L25.7092 11.2246C26.1412 10.7926 26.8419 10.7926 27.2746 11.2246L27.712 11.6614C28.144 12.0941 28.144 12.7947 27.712 13.2274L25.3656 15.5731"
                            stroke="currentColor"
                            strokeWidth="1.28132"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            id="Vector_21"
                            d="M12.6704 15.5727L10.324 13.227C9.892 12.7949 9.892 12.0936 10.324 11.6609L10.7615 11.2241C11.1941 10.7921 11.8949 10.7921 12.3269 11.2241L14.6733 13.5699"
                            stroke="currentColor"
                            strokeWidth="1.28132"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            id="Vector_22"
                            d="M12.672 23.2617L12.6699 15.5728"
                            stroke="currentColor"
                            strokeWidth="1.28132"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            id="Vector_23"
                            d="M14.6752 25.2643L12.3288 27.61C11.8968 28.0427 11.1961 28.0427 10.7634 27.61L10.326 27.1732C9.89395 26.7406 9.89395 26.0399 10.326 25.6072L12.6724 23.2615"
                            stroke="currentColor"
                            strokeWidth="1.28132"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            id="Vector_24"
                            d="M23.3621 25.2645L14.6738 25.2666"
                            stroke="currentColor"
                            strokeWidth="1.28132"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            id="Vector_25"
                            d="M25.3637 23.2615L27.7101 25.6072C28.1421 26.0399 28.1421 26.7406 27.7101 27.1732L27.2726 27.61C26.84 28.0427 26.1392 28.0427 25.7072 27.61L23.3608 25.2643"
                            stroke="currentColor"
                            strokeWidth="1.28132"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <g id="Group 161268617">
                        <path id="Vector_26" d="M20 20.6614L18 18.6614" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                        <path id="Vector_27" d="M18 20.6614L20 18.6614" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                    </g>
                </g>
            </g>
            <defs>
                <clipPath id="clip0_94_5380">
                    <rect width="38" height="38" fill="white" transform="translate(0 0.661377)" />
                </clipPath>
            </defs>
        </svg>
    );
}
